import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Box } from "@mui/material";
import { getJobExecutionsForVehiclesFilter } from "../../services/vehicle";
import { getDeploymentVehicleLogDetailsFilter } from "../../services/deployment";
import { getColumnsData } from "./VehicleDeploymentColumns";
import OTAPagination from "../OTAPagination";

const VehicleDeploymentList = (props = {}) => {
  console.log("VehicleDeploymentList props: ", props);
  let { vehicleId, deploymentId } = useParams();
  const {
    vehicles = [],
    type,
    setErrMsg = () => { },
    setShowJobDocument,
    jobStatusFilter,
  } = props;
  const [vehicle] = vehicles;

  const getVehicleExecutionsFn = useCallback(
    ({ queryKey }) => {
      return getJobExecutionsForVehiclesFilter({
        queryKey: [...queryKey, deploymentId, vehicle?.vehicleKey],
      });
    },
    [deploymentId, vehicle?.vehicleKey]
  );

  const getDeploymentLogFn = useCallback(
    ({ queryKey }) => {
      return getDeploymentVehicleLogDetailsFilter({
        queryKey: [...queryKey, deploymentId],
      });
    },
    [deploymentId]
  );

  const columns = getColumnsData({ vehicleId, deploymentId, type });
  const endpointFn = type === "vehicle" ? getVehicleExecutionsFn : getDeploymentLogFn;
  const queryName = type === "vehicle" ? "jobExecutionsForVehicle" : "deploymentVehicleLogs";

  return (
    <Grid item xs={12}>
      {/* Wrapper with bottom buffer below last record */}
      <Box
        sx={{
          "& .MuiDataGrid-root": {
            minHeight: "unset !important",
          },
          "& .MuiDataGrid-main": {
            minHeight: "170px",
          },
          // ✅ Add padding-bottom to virtual scroller to create space below last row
          "& .MuiDataGrid-virtualScroller": {
            minHeight: "auto",
            paddingBottom: "40px !important", // Space below last record
          },
          width: "100%",
        }}
      >
        <OTAPagination
          tableTitle={type === "vehicle" ? "" : "Vehicles in Deployment"}
          columns={columns}
          endpointFn={endpointFn}
          queryName={queryName}
          filterMode="server"
          sortByDefault={"createdAt"}
          getRowId={(row) => row.deploymentLogId ?? row.executionId}
          exportCSV={type !== "vehicle"}
          onSuccess={() => setShowJobDocument?.(true)}
          filters={
            jobStatusFilter
              ? [
                {
                  columnField: "jobExecutionStatus",
                  operatorValue: "equals",
                  value: jobStatusFilter,
                  label: "Job Status",
                  displayValue: jobStatusFilter,
                },
              ]
              : []
          }
          extraQueriesToInvalidate={["jobStatus"]}
          autoHeight={true}
        />
      </Box>
    </Grid>
  );
};

export default VehicleDeploymentList;